import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';

import { AppHeader } from '../../components/header/header';
import { PROJECTS } from '../../data/projects.data';

@Component({
  selector: 'app-project-overview-page',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    AppHeader
  ],
  templateUrl: './project-overview-page.html',
  styleUrl: './project-overview-page.scss'
})
export class ProjectOverviewPage {
  private readonly route = inject(ActivatedRoute);

  project = computed(() => {
    const slug = this.route.snapshot.paramMap.get('slug');

    return PROJECTS.find(project => project.slug === slug) ?? PROJECTS[0];
  });
}
